<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="c-form-item-area">
    <el-cascader
      ref="cascaderRef"
      v-bind="cascaderAttrs"
      :modelValue="innerModelValue"
      :disabled="disabled"
      :props="cascaderProps"
      :options="areaOptions"
      @change="handleChange"
    ></el-cascader>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, computed, watch, ref, onMounted, useCurrentAppInstance } from '@zto/zpage'
import { useFormItem } from '@zto/zpage-ui-element'

import { getAreasRef, loadAreas, getAreaData } from '../../../utils/areaMerged'

import type { GenericObject } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: GenericObject
    prop?: string
    props?: Array<any>
    disabled: boolean
    areaLevel?: number
    // multiple?: boolean // 暂不支持多选
    labelProps?: Array<any>
    propsConfig?: Record<string, any>
  }>(),
  {
    disabled: false
  }
)

const { innerAttrs } = useFormItem(props)

const app = useCurrentAppInstance()

const cascaderRef = ref<any>()

const innerModelValue = ref<any>([])

const areaOptions = computed(() => getAreasRef(props.areaLevel).value)

const cascaderProps = computed(() => {
  return {
    label: 'label',
    value: 'value',
    // multiple: props.multiple === true,
    ...props.propsConfig
  }
})

const cascaderAttrs = computed(() => {
  return {
    collapseTags: true,
    placeholder: '请选择',
    separator: '-',
    ...innerAttrs.value,
    props: [
      {
        label: 'label',
        value: 'value',
        // multiple: props.multiple === true,
        ...props.propsConfig
      }
    ]
  }
})

watch(
  () => props.prop && props.model[props.prop],
  () => {
    if (!props.prop) return
    innerModelValue.value = [...(props.model[props.prop] || [])]
  },
  { immediate: true }
)

watch(
  // 为了修复重置的时候时间显示不消失的问题
  () => props.model.provinceId,
  () => {
    if (!props.props?.length) return

    if (!props.model.provinceId) {
      innerModelValue.value = []
    }

    if (props.props?.length) {
      innerModelValue.value = [] // 先清空再push
      props.props.forEach((p: any) => {
        if (props.model[p]) {
          innerModelValue.value.push(props.model[p])
        }
      })
    }
  },
  { immediate: true }
)

// watch(
//   () => props.model.provinceIdList,
//   () => {
//     if (!props.model.provinceIdList) {
//       innerModelValue.value = []
//     }

//     props.props.forEach((it: any) => {
//       innerModelValue.value.push(props.model[it])
//     })
//   }
// )

onMounted(async () => {
  await loadAreas(app)
})

// 修改时触发
function handleChange(vals: any) {
  const valsData = (vals || []).map((it: string) => {
    return getAreaData(it)
  })

  if (props.props?.length) {
    props.props.forEach((it: any, index: number) => {
      props.model[it] = (valsData[index] || {})[cascaderProps.value.value]
    })
  }

  if (props.prop) {
    props.model[props.prop] = vals ? [...vals] : []
  }

  // 获取值对应的label
  if (props.labelProps?.length) {
    props.labelProps.forEach((it: any, index: number) => {
      props.model[it] = (valsData[index] || {})[cascaderProps.value.label]
    })
  }
}
</script>
